// General Scripts that Power the Website
import ClipboardJS from 'clipboard';

// Doc Ready & Turbolinks Load
if (window.$ !== undefined) {
  $(document).on('turbolinks:load', function () {

    // Avatar Dropdown
    const avatar = $('#user-menu');
    const flyout = $('#user-menu-flyout');
    avatar.on('click', (e) => {
      e.stopPropagation();
      flyout.removeClass('hidden');
    });

    // Mobile Menu
    const mobileMenu = $('#mobile-menu');
    const mobileMenuBtn = $('#toggle-mobile-menu');
    mobileMenuBtn.on('click', (e) => {
      e.stopPropagation();
      mobileMenu.toggleClass('hidden');
    });

    // New Campaign Modal
    const campaignModal = $('#new-campaign-modal');
    const campaignModalBtn = $('#new-campaign-modal-btn');
    const campaignModalCloseBtn = $('#new-campaign-modal-close-btn');
    campaignModalBtn.on('click', () => {
      campaignModal.removeClass('hidden');
    });
    campaignModalCloseBtn.on('click', () => {
      campaignModal.addClass('hidden');
    });

    // Manage Tag Modal
    const tagsModal = $('#manage-tags-modal');
    const tagsModalBtn = $('#manage-tags-modal-btn');
    const tagsModalCloseBtn = $('#manage-tags-modal-close-btn');
    tagsModalBtn.on('click', function (e) {
      e.preventDefault();
      tagsModal.removeClass('hidden');
    });
    tagsModalCloseBtn.on('click', () => {
      tagsModal.addClass('hidden');
    }); 
    
    // Block 
    $('#tag_submit_form').on('keypress', e => {
      if (e.keyCode == 13) return false;
    });

    // Campaign Embed Modal
    const campaignEmbedModal = $('#campaign-embed-modal');
    const campaignEmbedModalBtn = $('#campaign-embed-modal-btn');
    const campaignEmbedModalCloseBtn = $('#campaign-embed-modal-close-btn');
    campaignEmbedModalBtn.on('click', () => {
      campaignEmbedModal.removeClass('hidden');
    });
    campaignEmbedModalCloseBtn.on('click', () => {
      campaignEmbedModal.addClass('hidden');
    });  

    // Close any open things
    $('html').on('click', () => {
      flyout.addClass('hidden');
    });

    // Hide Notices
    const hideNotice = () => {
      const notice = $('#notice-notification');
      if (notice.length) {
        notice.remove();
      }
    }
    $('#hide-notice').on('click', () => hideNotice());
    setTimeout(hideNotice, 10000);

    // Comming Soon
    $('.coming-soon').on('click', () => {
      alert("This feature is coming soon! We'll send an announcement when it's ready!")
    })

    // Range Slider
    const isDateTargeted = $('#new_message_form').data('date-targeted') === true || $('#new_message_form').data('dateTargeted') === true;

    function genMsg (day) {
      let dayC = Number(day);
      if (isDateTargeted) {
        if (dayC === 0) {
          return `This message will be sent on the day of the event.`;
        } else {
          return `This message will be sent <span>${dayC} ${ (dayC === 1) ? "day" : "days" }</span> before the event.`;
        }
      } else {
        if (dayC === 0) {
          return `This message will be sent when the contact signs up.`;
        } else {
          return `This message will be sent <span>${dayC} ${ (dayC === 1) ? "day" : "days" }</span> after the contact signs up.`;
        }
      }
    }

    const updateTime = day => {
      const dayC = Number(day);
      const timeInput = $('.send-at-time');
      const timeNow   = $('#send_immediately');
      if (dayC === 0) {
        timeInput.hide();
        timeNow.show();
      } else {
        timeNow.hide();
        timeInput.show();
      }
    }

    const rangeSlider = function(){
      let slider = $('.range-slider'),
          range = $('.range-slider__range'),
          value = $('.range-slider__value');

      slider.each(function(){

        value.each(function(){
          let value = $(this).prev().attr('value');
          $(this).html(value);
          $('.day-zero-msg').html(genMsg(value));
          updateTime(value);
        });

        range.on('input', function(){
          $(this).next(value).html(this.value);
          $('.day-zero-msg').html(genMsg(this.value));
          updateTime(this.value);
        });
      });
    };
    rangeSlider();

    // Send Immediately Toggle (date-targeted message forms)
    const sendImmediatelyCheckbox = $('#send_immediately_checkbox');
    if (sendImmediatelyCheckbox.length) {
      const daysSliderSection = $('#days-slider-section');

      function toggleSendImmediately() {
        if (sendImmediatelyCheckbox.is(':checked')) {
          daysSliderSection.addClass('hidden');
          // Force days_after to 0
          $('.range-slider__range').val(0);
          $('.range-slider__value').html('0');
          $('.day-zero-msg').html('This message will be sent immediately when the contact signs up.');
        } else {
          daysSliderSection.removeClass('hidden');
        }
      }

      // Set initial state
      toggleSendImmediately();

      sendImmediatelyCheckbox.on('change', toggleSendImmediately);
    }

    // Campaign Scheduling Mode Toggle (follow-up index page)
    const schedulingEvergreen = $('#scheduling_mode_evergreen');
    const schedulingDateTargeted = $('#scheduling_mode_date_targeted');
    const dateTargetedFields = $('#date-targeted-fields');

    if (schedulingEvergreen.length && schedulingDateTargeted.length) {
      function toggleSchedulingMode() {
        if (schedulingDateTargeted.is(':checked')) {
          dateTargetedFields.removeClass('hidden');
        } else {
          dateTargetedFields.addClass('hidden');
          // Clear target date when switching to evergreen
          $('#campaign_target_date').val('');
        }
      }

      schedulingEvergreen.on('change', toggleSchedulingMode);
      schedulingDateTargeted.on('change', toggleSchedulingMode);
    }

    // Summernote
    const summernoteConfig = {
      height: 200,
      useProtocol: false,
      toolbar: [
        ['para', ['style']],
        ['para2', ['ol', 'ul']],
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['insert', ['link', 'hr', 'video']],
        ['mis', ['fullscreen']]
      ]
    };
    $("#summernote").summernote(summernoteConfig);
    $("#fallback-summernote").summernote(summernoteConfig);

    // Clipboard Initiate
    if ($(".clipboard").length) {
      const clipboard = new ClipboardJS('.clipboard');
      clipboard.on('success', function(e) {
        const currentText = $(e.trigger).text();
        $(e.trigger).text('COPIED!');
        setTimeout(() => {
          $(e.trigger).text(currentText);
        }, 700);
      });
    }

    // Delete Method Simple
    $(".deletealert").on("click", function () {
      if (window.confirm("Are you sure you want to do this? There is no going back.")) {
        return true;
      }
      return false;
    })  

    // Contacts Table Clickable
    $("#contacts-table").on('click', 'tr', function (e) {
      const link = $(this).data('href');
      if (link) {
        window.location = link;
      }
    });

    // Pricing Toggle
    if ($('#fd-monthly').length) {
      const monthly = $('#fd-monthly');
      const yearly = $('#fd-yearly');
      const monthlyElems = $('.fd-monthly');
      const yearlyElems = $('.fd-yearly');

      monthly.on('click', () => {
        yearly.removeClass('bg-primary text-white').addClass('text-gray-500');
        monthly.removeClass('text-gray-500').addClass('bg-primary text-white');
        yearlyElems.addClass('hidden');
        monthlyElems.removeClass('hidden');
      });

      yearly.on('click', () => {
        monthly.removeClass('bg-primary text-white').addClass('text-gray-500');
        yearly.removeClass('text-gray-500').addClass('bg-primary text-white');
        monthlyElems.addClass('hidden');
        yearlyElems.removeClass('hidden');
      });

    }

  });
}


// Rewardful Script
// 1. Check for params
// 2. If params, set cookie for 30 days.
const fdParams = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
function fdSetCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}
if (fdParams.rewardful) {
  console.log('Rewardful UUID', fdParams.rewardful);
  fdSetCookie('rewardfulUUID', fdParams.rewardful, 30);
}